import _ from 'lodash';
import template from './eventDetailsModal.html';
import { EventEmitter } from '@angular/core';


export default {
  name: 'eventDetailsModalComponent',
  template,
  controller: EventDetailsModalController,
  controllerAs: 'EventDetailsModalCtrl',
  bindings: {
    resolve: '<',
    dismiss: '&',
    close: '&'
  }
};

/* @ngInject */
function EventDetailsModalController($scope, hotkeys, EventsPanelService) {
  const vm = this;

  vm.current = 0;
  let changing = false;
  const LOAD_MORE_BUFFER = 5;
  vm.playVideo = playVideo;
  vm.acknowledgeThisEvent = acknowledgeThisEvent;
  vm.flagThisEvent = flagThisEvent;
  vm.triggerActiveItemChange = triggerActiveItemChange;
  vm.activeItemChange = new EventEmitter();

  vm.$onInit = () => {
    _.forEach(vm.resolve, (val, key) => {
      vm[key] = val;
    });

    setEvent(vm.theEvent);
  };

  vm.$postLink = () => {
    // listen
    $scope.$watch(() => vm.allEvents.length, () => {
      if (_.isEmpty(vm.allEvents)) {
        vm.close();
      } else {
        // TODO: Maybe combine this into a single call to setEvent instead
        vm.current = _.findIndex(vm.allEvents, { id: vm.theEvent.id });
      }
    });
  };

  function setEvent(eventToSet) {
    changing = true;
    vm.theEvent = eventToSet;

    if (vm.loadMore && (vm.allEvents.length - vm.current < LOAD_MORE_BUFFER)) {
      vm.loadMore().finally(() => {
        changing = false;
      });
    } else {
      changing = false;
    }

  }

  vm.canCycle = () => _.isArray(vm.allEvents) && vm.allEvents.length > 1;

  vm.prev = () => {
    if (!changing && vm.canCyclePrev()) {
      setEvent(vm.allEvents[++vm.current]);
    }
  };

  vm.canCyclePrev = () => vm.current + 1 < vm.allEvents.length;

  vm.next = () => {
    if (!changing && vm.canCycleNext()) {
      setEvent(vm.allEvents[--vm.current]);
    }
  };

  vm.canCycleNext = () => vm.current - 1 >= 0;

  vm.numberOfAllEvents = () => vm.allEvents.length;

  vm.deleteCurrentEvent = (currentEvent = getCurrentEvent()) => {
    vm.prev();
    return EventsPanelService.deleteThisEvent(vm.panelId, currentEvent);
  };

  vm.getEventPosition = () => `${vm.current + 1}/${vm.numberOfAllEvents()}`;

  function getCurrentEvent() {
    return vm.allEvents[vm.current];
  }

  function playVideo() {
    const video = document.getElementById(`video-${vm.allEvents[vm.current].id}`);
    if (video) {
      video.play();
    }
  }

  async function acknowledgeThisEvent() {
    await EventsPanelService.acknowledgeThisEvent(vm.allEvents[vm.current])
      .catch(_.noop);
  }

  async function flagThisEvent() {
    await EventsPanelService.flagThisEvent(vm.allEvents[vm.current])
      .catch(_.noop);
  }

  function triggerActiveItemChange(_event, hotkey) {
    vm.activeItemChange.emit({
      direction: hotkey.identifier
    });
  }

  // when bind it to the controller's scope, it will automatically unbind
  // the hotkey when the scope is destroyed (due to ng-if or something that changes the DOM)
  hotkeys.bindTo($scope)
    .add({
      combo: ['left'],
      description: 'Go to previous event',
      callback: vm.prev
    })
    .add({
      combo: ['j'],
      description: 'Go to previous event',
      callback: vm.prev
    })
    .add({
      combo: ['right'],
      description: 'Go to next event',
      callback: vm.next
    })
    .add({
      combo: ['k'],
      description: 'Go to next event',
      callback: vm.next
    })
    .add({
      combo: ['s'],
      identifier: 'previous',
      description: 'Go to previous thumbnail',
      callback: vm.triggerActiveItemChange
    })
    .add({
      combo: ['d'],
      identifier: 'next',
      description: 'Go to next thumbnail',
      callback: vm.triggerActiveItemChange
    })
    .add({
      combo: ['a'],
      description: 'Acknowledge Event',
      callback: vm.acknowledgeThisEvent
    })
    .add({
      combo: ['p'],
      description: 'Play Video',
      callback: vm.playVideo
    })
    .add({
      combo: ['f'],
      description: 'Flag Event',
      callback: vm.flagThisEvent
    });
}
